/**
 * Created by mykurisu on 2017/11/21.
 */

const defaults = {
    showFocusDialog: false,
    showShareDialog: false
};

export default (state = defaults, action) => {
    switch (action.type) {
        case 'DEEP_FOCUS_DIALOG_SHOW':
            return {...state, showFocusDialog: true};
        case 'DEEP_FOCUS_DIALOG_HIDE':
            return {...state, showFocusDialog: false};
        case 'DEEP_SHARE_DIALOG_SHOW':
            return {...state, showShareDialog: true};
        case 'DEEP_SHARE_DIALOG_HIDE':
            return {...state, showShareDialog: false};
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/reducers/details.js